import {CaseForms, PageForms} from "../../../helpers/enums";

import DenunciaPerdite from "./DenunciaPerdite";
import Test from "./Test";
import Voltura from "./Voltura";
import RichiediInformazioni from "./RichiediInformazioni";
import DomiciliazioneBancaria from "./DomiciliazioneBancaria";

import AvvenutoPagamento from './AvvenutoPagamento';
import DisattivazioneDellaFornitura from './DisattivazioneDellaFornitura';
import RateizzazioneBolletta from "./RateizzazioneBolletta";
import RettificaFatturazione from "./RettificaFatturazione";
import FaiUnReclamo from "./FaiUnReclamo";
import PreventivoLavori from "./PreventivoLavori";
import AnalisiAcqua from './AnalisiAcqua';
import SegnalaUnGuasto from './SegnalaUnGuasto';
import TutelaPerdite from './TutelaPerdite';
import AppuntamentoPuntoAcqua from './AppuntamentoPuntoAcqua';
import VerificaMetrica from './VerificaMetrica';
import EstensioneReteEsistente from './EstensioneReteEsistente';
import VerificaContatore from './VerificaContatore';
import VerificaDellaPressione from './VerificaDellaPressione';
import ModificaDati from './ModificaDati';
import Allacciamento from "./Allacciamento";
import AllacciamentoFognatura from "./AllacciamentoFognatura";
import LetturaSicuraAttiva from "./LetturaSicuraAttiva";
import LetturaSicuraDisattiva from "./LetturaSicuraDisattiva";
// import RichiediOmaggio from "./RichiediOmaggio";
import Subentro from "./Subentro";
import SelfReadingOperator from "./SelfReadingOperator";
import SpidRegister from "./SpidRegister";
import RichiediSpurghiCase from "./RichiediSpurghiCase";
import DomiciliazioneBancariaComplex from "./DomiciliazioneBancariaComplex";
import AggiornaDati from "./AggiornaDati";
import ModificaDomiciliazioneBancariaComplex from "./ModificaDomiciliazioneBancariaComplex";
import AssociaContrattoAmministratore from "./AssociaContrattoAmministratore"

export const Cases = {
  [CaseForms.Allaccio]: Allacciamento,
  [CaseForms.DenunciaPerdite]: DenunciaPerdite,
  [CaseForms.Test]: Test,
  [CaseForms.DomiciliazioneBancariaComplex]: DomiciliazioneBancariaComplex,
  [CaseForms.Voltura]: Voltura,
  [CaseForms.RichiediSpurghiCase]: RichiediSpurghiCase,
  [CaseForms.RichiediInformazioni]: RichiediInformazioni,
  [CaseForms.DomiciliazioneBancaria]: DomiciliazioneBancaria,
  [CaseForms.DisattivazioneDellaFornitura]: DisattivazioneDellaFornitura,
  [CaseForms.AvvenutoPagamento]: AvvenutoPagamento,
  [CaseForms.RateizzazioneBolletta]: RateizzazioneBolletta,
  [CaseForms.RettificaFatturazione]: RettificaFatturazione,
  [CaseForms.FaiUnReclamo]: FaiUnReclamo,
  [CaseForms.PreventivoLavori]: PreventivoLavori,
  [CaseForms.AnalisiAcqua]: AnalisiAcqua,
  [CaseForms.SegnalaUnGuasto]: SegnalaUnGuasto,
  [CaseForms.TutelaPerdite]: TutelaPerdite,
  [CaseForms.AppuntamentoPuntoAcqua]: AppuntamentoPuntoAcqua,
  [CaseForms.VerificaMetrica]: VerificaMetrica,
  [CaseForms.EstensioneReteEsistente]: EstensioneReteEsistente,
  [CaseForms.VerificaContatore]: VerificaContatore,
  [CaseForms.VerificaDellaPressione]: VerificaDellaPressione,
  [CaseForms.ModificaDati]: ModificaDati,
  [CaseForms.Fognatura]: AllacciamentoFognatura,
  [CaseForms.LetturaSicuraAttiva]: LetturaSicuraAttiva,
  [CaseForms.LetturaSicuraDisattiva]: LetturaSicuraDisattiva,
  // [CaseForms.RichiediOmaggio]: RichiediOmaggio,
  [CaseForms.Subentro]: Subentro,
  [CaseForms.SpidRegister]: SpidRegister,
  [PageForms.SelfReadingOperator]: SelfReadingOperator,
  [CaseForms.AggiornaDati]: AggiornaDati,
  [CaseForms.ModificaDomiciliazioneBancariaComplex]: ModificaDomiciliazioneBancariaComplex,
  [CaseForms.AssociaContrattoAmministratore]: AssociaContrattoAmministratore
}

